<template>

    <div class="calculator-output-item" :item-name="name">
        <div class="inner-output-item" >
            <h3><span>{{ symbol }}</span>{{ result }}</h3>
            <h6>{{ caption }}</h6>
        </div>

    </div>

</template>

<script>
	export default {
		name: "calculatorOutput",
        props : ['result' , 'caption' ,'name' , 'symbol'],
	  updated: function () {
	    this.$nextTick( function () {
	      $('.inner-output-item h3').each(function(){
              if (typeof dynamicInputFontText != 'undefined') {
                  dynamicInputFontText.adjustFontSize($(this));
              }
	      })
	    } );
    }
	}
</script>

<style lang="scss">

    .assets-calculator{
        .calculator-output-item{
            h3, h6{
                font-weight: normal;
            }
        }

        &[data-from-state="inComplete"]{
            .calculator-output-item{
                color: #3d3d3d;
            }
        }
        &[data-submit-state="before"]{
            .inner-output-item{
                h3 span{
                    display: none;
                }
            }
        }
        &[data-from-state="completed"]{
            &[data-submit-state="before"]{
                .calculator-output-item{
                    h3{
                        color: #3d3d3d;

                    }

                    h6{
                        color: #cccccc;

                    }
                }

            }
            &[data-submit-state="after"]{
                .calculator-output-item{
                    color: #dfe4eb;
                    box-shadow: -9px 14px 19px -4px rgba(0, 0, 0, 0.05);
                    &[item-name="total"]{
                        background-color: #ffc900;
                        color:#1d1d1d ;
                        h3 ,h6{
                            font-weight: 500;
                        }
                    }
                }

            }

        }
    }


    .calculator-output-item{
        position: relative;
        background-color: #252525;
        width: 25%;
        text-align: center;
        border-radius: 6px;
        height: 120px;

        @media (max-width: 480px){
            margin-bottom: 9px;
        }

        h3{
            font-size: 36px;
            margin: 0;
            color: inherit;
            line-height: inherit;
            padding: 0 5px;
        }
        h6{
            font-size: 16px;
            margin: 0;
        }
        &:not(:last-child){
            margin-right: 1.3%;
            .rtl &{
                @media (min-width: 938px){
                    margin-right: 0;
                    margin-left: 1.3%;
                }
            }
            @media (max-width: 938px) and (min-width: 480px){
                margin-right: 1.1%;
                .rtl &{
                    margin-right: 0;
                    margin-left: 1.3%;
                }
            }
            @media (max-width: 480px){
                margin-right: 0;
                margin-left: 0;
            }
        }


        .inner-output-item{
            position: absolute;
            top:50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 90%;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/calculatorOutput/calculatorOutput.vue